module.exports = __webpack_public_path__ + "img/chrome.053ff298.png";